import {
  HeadContent,
  Outlet,
  Scripts,
  createRootRoute,
} from "@tanstack/react-router";
import { I18nProvider } from "@lingui/react";
import { i18n } from "../i18n";
import NotFoundPage from "../components/NotFoundPage";

import ConvexProvider from "../integrations/convex/provider";

import appCss from "../styles.css?url";

export const Route = createRootRoute({
  component: RootComponent,
  head: () => ({
    links: [
      {
        href: appCss,
        rel: "stylesheet",
      },
      {
        href: "/favicon.ico",
        rel: "icon",
        sizes: "any",
      },
      {
        href: "/icon.png",
        rel: "icon",
        sizes: "32x32",
        type: "image/png",
      },
      {
        href: "/apple-icon.png",
        rel: "apple-touch-icon",
        sizes: "180x180",
      },
      {
        href: "/manifest.json",
        rel: "manifest",
      },
    ],
    meta: [
      {
        charSet: "utf8",
      },
      {
        content: "width=device-width, initial-scale=1",
        name: "viewport",
      },
      {
        title: "BodaWeb — Crea Tu Invitación de Boda",
      },
    ],
  }),
  notFoundComponent: NotFoundPage,
  shellComponent: RootDocument,
});

function RootComponent() {
  return <Outlet />;
}

function RootDocument({ children }: { children: React.ReactNode }) {
  return (
    <html lang="es">
      <head>
        <HeadContent />
      </head>
      <body>
        <I18nProvider i18n={i18n}>
          <ConvexProvider>{children}</ConvexProvider>
        </I18nProvider>
        <Scripts />
      </body>
    </html>
  );
}
